import {SvgIcon} from "@mui/material";

export default function FilterIcon(props) {
    return (
        <SvgIcon viewBox={`0 0 24 24`} fill="none"
                 xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_277_5668)">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L7.41421 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.41421L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289Z"
                      fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_277_5668">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </SvgIcon>
    );
}
